module.exports = __webpack_public_path__ + "static/img/attendance-reward-btn-bg.91b29b0.png";